import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import { ReactComponent as TrainingToCorrectIcon } from "../../../assets/img/icons/toCorrect.svg";

const TrainingIcon = (props: any) => {
  const { type = "Courses", percentage = 100, state = "" } = props;
  let icon = (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.91406 0C9.65819 0 9.40228 0.0977188 9.20703 0.292969L8 1.5L10.5 4L11.707 2.79297C12.0975 2.40247 12.0975 1.76941 11.707 1.37891L10.6211 0.292969C10.4258 0.0977188 10.1699 0 9.91406 0ZM7 2.5L1.12988 8.37012C1.12988 8.37012 1.58877 8.329 1.75977 8.5C1.93077 8.671 1.79 9.79 2 10C2.21 10.21 3.32195 10.0622 3.48145 10.2217C3.64095 10.3812 3.62988 10.8701 3.62988 10.8701L9.5 5L7 2.5ZM0.5 10L0.0283203 11.3359C0.00977771 11.3887 0.000204918 11.4441 0 11.5C0 11.6326 0.0526784 11.7598 0.146447 11.8536C0.240215 11.9473 0.367392 12 0.5 12C0.555886 11.9998 0.611342 11.9902 0.664063 11.9717C0.665694 11.971 0.667321 11.9704 0.668945 11.9697L0.681641 11.9658L0.68457 11.9639L2 11.5L1.25 10.75L0.5 10Z"
        fill="#8D8D8D"
      />
    </svg>
  );
  let bColor = "#BDBDBD";
  if (state === "pending") {
    icon = (
      <svg
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.99967 2.33332V0.841651C6.99967 0.466651 6.54967 0.283318 6.29134 0.549985L3.95801 2.87498C3.79134 3.04165 3.79134 3.29998 3.95801 3.46665L6.28301 5.79165C6.54967 6.04998 6.99967 5.86665 6.99967 5.49165V3.99998C9.75801 3.99998 11.9997 6.24165 11.9997 8.99998C11.9997 9.65832 11.8747 10.3 11.633 10.875C11.508 11.175 11.5997 11.5167 11.8247 11.7417C12.2497 12.1667 12.9663 12.0167 13.1913 11.4583C13.4997 10.7 13.6663 9.86665 13.6663 8.99998C13.6663 5.31665 10.683 2.33332 6.99967 2.33332ZM6.99967 14C4.24134 14 1.99967 11.7583 1.99967 8.99998C1.99967 8.34165 2.12467 7.69998 2.36634 7.12498C2.49134 6.82498 2.39967 6.48332 2.17467 6.25832C1.74967 5.83332 1.03301 5.98332 0.808008 6.54165C0.499675 7.29998 0.333008 8.13332 0.333008 8.99998C0.333008 12.6833 3.31634 15.6667 6.99967 15.6667V17.1583C6.99967 17.5333 7.44967 17.7167 7.70801 17.45L10.033 15.125C10.1997 14.9583 10.1997 14.7 10.033 14.5333L7.70801 12.2083C7.44967 11.95 6.99967 12.1333 6.99967 12.5083V14Z"
          fill="#3367CD"
        />
      </svg>
    );
    bColor="#3367CD;";
  }
  if (state === "published") {
    icon = (
      <svg
        width="14"
        height="12"
        viewBox="0 0 14 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.42392 0C0.82119 0 0.333008 0.488182 0.333008 1.09091V3.27273H13.4239V1.09091C13.4239 0.488182 12.9357 0 12.333 0H1.42392ZM1.96937 1.09091C2.27046 1.09091 2.51483 1.33527 2.51483 1.63636C2.51483 1.93745 2.27046 2.18182 1.96937 2.18182C1.66828 2.18182 1.42392 1.93745 1.42392 1.63636C1.42392 1.33527 1.66828 1.09091 1.96937 1.09091ZM4.15119 1.09091C4.45228 1.09091 4.69664 1.33527 4.69664 1.63636C4.69664 1.93745 4.45228 2.18182 4.15119 2.18182C3.8501 2.18182 3.60573 1.93745 3.60573 1.63636C3.60573 1.33527 3.8501 1.09091 4.15119 1.09091ZM0.333008 4.36364V11.4545C0.333022 11.5992 0.390494 11.7379 0.492784 11.8402C0.595073 11.9425 0.733803 12 0.878462 12H12.8785C13.0231 12 13.1618 11.9425 13.2641 11.8402C13.3664 11.7379 13.4239 11.5992 13.4239 11.4545V4.36364H12.333V10.9091H1.42392V4.36364H0.333008ZM2.51483 4.36364V9.81818H6.33301V4.36364H2.51483ZM7.96937 4.36364C7.89709 4.36261 7.82533 4.37597 7.75826 4.40292C7.69118 4.42987 7.63013 4.46989 7.57866 4.52064C7.52718 4.57139 7.48631 4.63187 7.45841 4.69855C7.43051 4.76524 7.41615 4.8368 7.41615 4.90909C7.41615 4.98138 7.43051 5.05294 7.45841 5.11963C7.48631 5.18631 7.52718 5.24679 7.57866 5.29754C7.63013 5.34829 7.69118 5.38831 7.75826 5.41526C7.82533 5.44221 7.89709 5.45557 7.96937 5.45455H10.6966C10.7689 5.45557 10.8407 5.44221 10.9078 5.41526C10.9748 5.38831 11.0359 5.34829 11.0874 5.29754C11.1388 5.24679 11.1797 5.18631 11.2076 5.11963C11.2355 5.05294 11.2499 4.98138 11.2499 4.90909C11.2499 4.8368 11.2355 4.76524 11.2076 4.69855C11.1797 4.63187 11.1388 4.57139 11.0874 4.52064C11.0359 4.46989 10.9748 4.42987 10.9078 4.40292C10.8407 4.37597 10.7689 4.36261 10.6966 4.36364H7.96937ZM7.96937 6.54545C7.89709 6.54443 7.82533 6.55779 7.75826 6.58474C7.69118 6.61169 7.63013 6.65171 7.57866 6.70246C7.52718 6.75321 7.48631 6.81369 7.45841 6.88037C7.43051 6.94706 7.41615 7.01862 7.41615 7.09091C7.41615 7.1632 7.43051 7.23476 7.45841 7.30145C7.48631 7.36813 7.52718 7.42861 7.57866 7.47936C7.63013 7.53011 7.69118 7.57013 7.75826 7.59708C7.82533 7.62403 7.89709 7.63739 7.96937 7.63636H10.6966C10.7689 7.63739 10.8407 7.62403 10.9078 7.59708C10.9748 7.57013 11.0359 7.53011 11.0874 7.47936C11.1388 7.42861 11.1797 7.36813 11.2076 7.30145C11.2355 7.23476 11.2499 7.1632 11.2499 7.09091C11.2499 7.01862 11.2355 6.94706 11.2076 6.88037C11.1797 6.81369 11.1388 6.75321 11.0874 6.70246C11.0359 6.65171 10.9748 6.61169 10.9078 6.58474C10.8407 6.55779 10.7689 6.54443 10.6966 6.54545H7.96937ZM7.96937 8.72727C7.89709 8.72625 7.82533 8.7396 7.75826 8.76656C7.69118 8.79351 7.63013 8.83352 7.57866 8.88428C7.52718 8.93503 7.48631 8.9955 7.45841 9.06219C7.43051 9.12888 7.41615 9.20044 7.41615 9.27273C7.41615 9.34501 7.43051 9.41658 7.45841 9.48327C7.48631 9.54995 7.52718 9.61043 7.57866 9.66118C7.63013 9.71193 7.69118 9.75194 7.75826 9.7789C7.82533 9.80585 7.89709 9.8192 7.96937 9.81818H10.6966C10.7689 9.8192 10.8407 9.80585 10.9078 9.7789C10.9748 9.75194 11.0359 9.71193 11.0874 9.66118C11.1388 9.61043 11.1797 9.54995 11.2076 9.48327C11.2355 9.41658 11.2499 9.34501 11.2499 9.27273C11.2499 9.20044 11.2355 9.12888 11.2076 9.06219C11.1797 8.9955 11.1388 8.93503 11.0874 8.88428C11.0359 8.83352 10.9748 8.79351 10.9078 8.76656C10.8407 8.7396 10.7689 8.72625 10.6966 8.72727H7.96937Z"
          fill="#50BD89"
        />
      </svg>
    );
    bColor="#50BD89";
  }
  if (state === "ongoing_review") {
    icon = (
      <svg
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.99967 2.33332V0.841651C6.99967 0.466651 6.54967 0.283318 6.29134 0.549985L3.95801 2.87498C3.79134 3.04165 3.79134 3.29998 3.95801 3.46665L6.28301 5.79165C6.54967 6.04998 6.99967 5.86665 6.99967 5.49165V3.99998C9.75801 3.99998 11.9997 6.24165 11.9997 8.99998C11.9997 9.65832 11.8747 10.3 11.633 10.875C11.508 11.175 11.5997 11.5167 11.8247 11.7417C12.2497 12.1667 12.9663 12.0167 13.1913 11.4583C13.4997 10.7 13.6663 9.86665 13.6663 8.99998C13.6663 5.31665 10.683 2.33332 6.99967 2.33332ZM6.99967 14C4.24134 14 1.99967 11.7583 1.99967 8.99998C1.99967 8.34165 2.12467 7.69998 2.36634 7.12498C2.49134 6.82498 2.39967 6.48332 2.17467 6.25832C1.74967 5.83332 1.03301 5.98332 0.808008 6.54165C0.499675 7.29998 0.333008 8.13332 0.333008 8.99998C0.333008 12.6833 3.31634 15.6667 6.99967 15.6667V17.1583C6.99967 17.5333 7.44967 17.7167 7.70801 17.45L10.033 15.125C10.1997 14.9583 10.1997 14.7 10.033 14.5333L7.70801 12.2083C7.44967 11.95 6.99967 12.1333 6.99967 12.5083V14Z"
          fill="#3367CD"
        />
      </svg>
    );
    bColor="#3367CD;";
  }
  if (state === "to_correct") {
    icon = (<TrainingToCorrectIcon />);
    bColor="#FF66A9";
  }
  if (type === "Courses" && percentage === 100) {
    return (
      <CircularProgressbarWithChildren
        value={100}
        background={true}
        styles={{
          root: {},
          path: {
            stroke: `rgb(80, 189, 137)`,
            strokeLinecap: "butt",
            transition: "stroke-dashoffset 0.5s ease 0s",
            strokeWidth: "3px",
          },
          trail: {
            stroke: "rgb(255,255, 255)",
            strokeLinecap: "butt",
            strokeWidth: "10px",
          },
          background: {
            fill: "#50BD89",
          },
        }}
      >
        <svg
          width="12"
          height="9"
          viewBox="0 0 12 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.99975 6.80013L1.66642 4.46679C1.40642 4.20679 0.993086 4.20679 0.733086 4.46679C0.473086 4.72679 0.473086 5.14013 0.733086 5.40013L3.52642 8.19346C3.78642 8.45346 4.20642 8.45346 4.46642 8.19346L11.5331 1.13346C11.7931 0.87346 11.7931 0.460127 11.5331 0.200127C11.2731 -0.059873 10.8597 -0.059873 10.5997 0.200127L3.99975 6.80013Z"
            fill="white"
          />
        </svg>
      </CircularProgressbarWithChildren>
    );
  }
  if (type === "Created") {
    return (
      <CircularProgressbarWithChildren
        value={0}
        background={true}
        styles={{
          root: {},
          path: {
            stroke: `rgb(80, 189, 137)`,
            strokeLinecap: "butt",
            transition: "stroke-dashoffset 0.5s ease 0s",
            strokeWidth: "3px",
          },
          trail: {
            stroke: "rgb(255,255, 255)",
            strokeLinecap: "butt",
            strokeWidth: "10px",
          },
          background: {
            fill: bColor,
            opacity: 0.2
          },
        }}
      >
        {icon}
      </CircularProgressbarWithChildren>
    );
  }
  return (
    <CircularProgressbar
      value={percentage}
      text={`${percentage}%`}
      background={true}
      styles={{
        root: {},
        path: {
          stroke:
            percentage > 50 && percentage < 100
              ? `rgb(51, 103, 205)`
              : `rgb(237, 152, 79)`,
          strokeLinecap: "butt",
          transition: "stroke-dashoffset 0.5s ease 0s",
          strokeWidth: "3px",
        },
        trail: {
          stroke: "rgb(255,255, 255)",
          strokeLinecap: "butt",
          strokeWidth: "10px",
        },
        background: {
          fill: percentage > 50 && percentage < 100 ? "#3367CD" : "#ED984F",
        },
        text: {
          color: "#FFFFFF",
          fill: "#FFFFFF",
        },
      }}
    />
  );
};

export default TrainingIcon;
